<template>
  <article class="contact-card">
    <header class="contact-card__header">
      <p class="contact-card__eyebrow">Nous contacter</p>
      <h5 class="jaapokki">Toutes les coordonnees utiles</h5>
      <p class="contact-card__copy">
        Choisissez le canal le plus simple pour echanger avec l'equipe de
        l'Institut Taxi.
      </p>
    </header>

    <ul class="contact-card__list">
      <li v-for="item in contactItems" :key="item.title">
        <a
          :href="item.href"
          class="contact-card__item"
          :target="item.external ? '_blank' : null"
          :rel="item.external ? 'noopener noreferrer' : null"
        >
          <span class="contact-card__icon" aria-hidden="true">
            <i :class="item.icon"></i>
          </span>
          <span class="contact-card__body">
            <strong>{{ item.title }}</strong>
            <span>{{ item.value }}</span>
          </span>
        </a>
      </li>
    </ul>
  </article>
</template>

<script>
const contactItems = [
  {
    title: "Venir au centre",
    value: "10 rue de la Sabliere, 92230 Gennevilliers",
    href: "https://www.google.com/maps/search/?api=1&query=10+Rue+de+la+Sabliere+92230+Gennevilliers",
    icon: "fas fa-map-marker-alt",
    external: true,
  },
  {
    title: "Nous ecrire",
    value: "contact@institut-taxi.fr",
    href: "mailto:contact@institut-taxi.fr",
    icon: "fas fa-envelope",
  },
  {
    title: "Telephone fixe",
    value: "01 41 11 22 32",
    href: "tel:+33141112232",
    icon: "fas fa-phone",
  },
  {
    title: "Telephone mobile",
    value: "07 87 18 59 18",
    href: "tel:+33787185918",
    icon: "fas fa-mobile",
  },
];

export default {
  name: "contactCard",
  data() {
    return {
      contactItems,
    };
  },
};
</script>

<style lang="scss" scoped>
.contact-card {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 100%;
  padding: clamp(24px, 2.8vw, 34px);
  border-radius: 28px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(0, 42, 84, 0.08);
  border: 1px solid rgba(0, 42, 84, 0.08);

  &__header {
    display: grid;
    gap: 10px;
  }

  &__eyebrow {
    margin: 0;
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(0, 42, 84, 0.58);
  }

  & h5 {
    margin: 0;
    color: $color-primary;
    font-size: clamp(1.45rem, 1.2rem + 0.4vw, 1.8rem);
    line-height: 1.05;
  }

  &__copy {
    margin: 0;
    font-size: 0.98rem;
    line-height: 1.6;
    color: rgba(88, 89, 91, 0.92);
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 12px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 14px;
    min-height: 82px;
    padding: 14px 16px;
    border-radius: 20px;
    background: rgba(0, 42, 84, 0.03);
    border: 1px solid rgba(0, 42, 84, 0.07);
    text-decoration: none;
    transition: transform 0.22s ease, box-shadow 0.22s ease,
      border-color 0.22s ease, background-color 0.22s ease;

    &:hover,
    &:focus-visible {
      transform: translateY(-2px);
      background: rgba(254, 185, 20, 0.12);
      border-color: rgba(254, 185, 20, 0.34);
      box-shadow: 0 14px 26px rgba(0, 42, 84, 0.08);
      outline: none;
    }
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background: $color-primary;
    color: $color-secondary;
    flex: 0 0 auto;

    & i {
      font-size: 1.1rem;
    }
  }

  &__body {
    display: grid;
    gap: 4px;
    min-width: 0;

    & strong {
      font-size: 0.92rem;
      line-height: 1.2;
      color: $color-primary;
    }

    & span {
      font-size: 0.95rem;
      line-height: 1.45;
      color: $color-text;
      overflow-wrap: anywhere;
    }
  }
}

@media screen and (max-width: 767px) {
  .contact-card {
    padding: 22px;
    border-radius: 24px;

    &__item {
      min-height: 78px;
    }
  }
}
</style>
